import {
  scDevelopmentCard1,
  scDevelopmentCard2,
  scDevelopmentCard3,
} from '~/assets/images'

export const bigCards = [
  {
    image: scDevelopmentCard1,
    title: 'smart-contract-development.big-cards.shorten-time.title',
    description:
      'smart-contract-development.big-cards.shorten-time.description',
  },
  {
    image: scDevelopmentCard2,
    title: 'smart-contract-development.big-cards.control-economy.title',
    description:
      'smart-contract-development.big-cards.control-economy.description',
  },
  {
    image: scDevelopmentCard3,
    title: 'smart-contract-development.big-cards.reach-audiences.title',
    description:
      'smart-contract-development.big-cards.reach-audiences.description',
  },
]
